import React from 'react'

import { AmpStickyAd } from './AmpStickyAd'
import { createRegisterableComponent } from 'common/routing/page-definition'
import { AdDefinition } from 'common/advertising/add-ads'

export type AmpStickyAdUnitRouteProps = { slot: AdDefinition }

export const AmpStickyAdUnitRegistration = createRegisterableComponent(
    'amp-sticky-ad-unit',
    (props: AmpStickyAdUnitRouteProps, services) => {
        return <AmpStickyAd adState={services.adState} unitId={props.slot.id} />
    }
)
